import { gsap } from "gsap";

export default {
    init() {

        if ($(".module-scroll-img")[0]) {
            $(".module-scroll-img").each(function() {
               
                var scrollImage = $(".module-scroll-img");
                
                const ele = scrollImage.find(".main-el")[0];
                ele.style.cursor = 'grab';
                    
                let pos = { top: 0, left: 0, x: 0, y: 0 };
                    
                const mouseDownHandler = function(e) {
                    ele.style.cursor = 'grabbing';
                    ele.style.userSelect = 'none';
                    
                    pos = {
                        left: ele.scrollLeft,
                        top: ele.scrollTop,
                        // Get the current mouse position
                        x: e.clientX,
                        y: e.clientY,
                    };
                    
                    document.addEventListener('mousemove', mouseMoveHandler);
                    document.addEventListener('mouseup', mouseUpHandler);
                };
                    
                const mouseMoveHandler = function(e) {
                    
                    // How far the mouse has been moved
                    const dx = e.clientX - pos.x;
                    const dy = e.clientY - pos.y;
                    
                    // Scroll the element
                    ele.scrollTop = pos.top - dy;
                    ele.scrollLeft = pos.left - dx;
                };
                    
                const mouseUpHandler = function() {
                    
                    ele.style.cursor = 'grab';
                    ele.style.removeProperty('user-select');
                    
                    document.removeEventListener('mousemove', mouseMoveHandler);
                    document.removeEventListener('mouseup', mouseUpHandler);
                };
                    
                // Attach the handler
                ele.addEventListener('mousedown', mouseDownHandler);

                function showLegend(clickedPuce) {

                    var animation = gsap.timeline({});

                    animation.to(clickedPuce.find(".legendes>line"), {
                        duration: 1,
                        attr: { y2: 150 },
                        ease: "expo.out"
                    });

                    animation.to(clickedPuce.find(".title_legend"), {
                        duration: 1,
                        y: -10,
                        opacity: 1,
                        ease: "expo.out"
                    }, "-=0.8");

                    animation.to(clickedPuce.find(".text_legend"), {
                        duration: 1,
                        y: 25,
                        opacity: 1,
                        ease: "expo.out"
                    }, "-=0.8");

                }

                function hideLegend(clickedPuce) {
                    var animation = gsap.timeline({});

                    animation.to(clickedPuce.find(".title_legend"), {
                        duration: 1,
                        y: 10,
                        opacity: 0,
                        ease: "expo.out"
                    }, 0);
                    animation.to(clickedPuce.find(".text_legend"), {
                        duration: 1,
                        y: 20,
                        opacity: 0,
                        ease: "expo.out"
                    }, 0);

                    animation.to(clickedPuce.find(".legendes>line"), {
                        duration: 1,
                        attr: { y2: 0 },
                        ease: "expo.out"
                    }, "-=0.8");
                }

                if (scrollImage.find(".concentrique")[0]) {


                    /* Animation de pulsation sur la puce */
                    var anim = gsap.timeline({
                        repeat: -1
                    });
                    anim.to(scrollImage.find(".concentrique"), {
                        duration: 1,
                        scale: 1.5,
                        ease: "expo.out"
                    });
                    anim.to(scrollImage.find(".concentrique"), {
                        duration: 1,
                        opacity: 0,
                        ease: "expo.out"
                    }, "-=0.6");

                    // Animation d'apparition des légendes au clic de la puce
                    scrollImage.find(".puces").on('click', function() {

                        var clickedPuce = $(this).parent();

                        if (clickedPuce.find(".legendes>line").attr("y2") == 0) {
                            showLegend(clickedPuce);
                        } else {
                            hideLegend(clickedPuce);
                        }

                    });
                }
            });
        }
    }
}